import PropTypes from 'prop-types';
import { status } from 'constants/general';
import OrdersHeader from 'modules/shared/orders/components/OrdersHeader';
import OrdersFilter from 'modules/shared/orders/components/OrdersFilter';
import OrdersList from 'modules/shared/orders/components/OrdersList';
import Loader from 'modules/shared/common/components/Loader';
import Pagination from 'modules/shared/common/components/Pagination';

import Can from 'modules/shared/common/components/Can';
import { OrdersWrapper, LoaderWrapper, PaginationWrapper } from './OrdersComponent.style';

const OrdersComponent = ({
  selectedDateFilterObj,
  selectedPageFilter,
  numberOfPages,
  ordersList,
  mappedOrdersList,
  orderStatusColorEnum,
  stringsData,
  selectedStatusFilter,
  ordersStatusFilterList,
  ordersApiCallParams,
  filters,
  handleOrderStatusFilterClick,
  handleOrderSearchBarInputChange,
  handleOrderDateFilterChange,
  handleOrderPaginationClick,
  handleGenericFilterClick,
  handleGenericMultiFitlerClick,
  partnershipTypes,
  showPartnersColumn,
  showPaymentColumn,
  permissionsCategories,
}) => (
  <Can
    permissionsCategory={permissionsCategories?.order}
    perform="order:viewAllOrders"
    renderYes={() => (
      <>
        <OrdersHeader
          stringsData={stringsData}
          selectedStatusFilter={selectedStatusFilter}
          ordersStatusFilterList={ordersStatusFilterList}
          handleOrderStatusFilterClick={handleOrderStatusFilterClick}
        />
        <OrdersWrapper>
          <OrdersFilter
            stringsData={stringsData}
            selectedDateFilterObj={selectedDateFilterObj}
            handleOrderSearchBarInputChange={handleOrderSearchBarInputChange}
            handleOrderDateFilterChange={handleOrderDateFilterChange}
            handleGenericFilterClick={handleGenericFilterClick}
            handleGenericMultiFitlerClick={handleGenericMultiFitlerClick}
            ordersApiCallParams={ordersApiCallParams}
            filters={filters}
          />
          {ordersList.status === status.SUCCESS || ordersList.status === status.FAIL ? (
            <>
              <OrdersList
                mappedOrdersList={mappedOrdersList}
                orderStatusColorEnum={orderStatusColorEnum}
                stringsData={stringsData}
                partnershipTypes={partnershipTypes}
                showPartnersColumn={showPartnersColumn}
                showPaymentColumn={showPaymentColumn}
              />
              {numberOfPages > 1 && (
                <PaginationWrapper>
                  <Pagination
                    currentPage={selectedPageFilter}
                    totalCount={numberOfPages}
                    handleOrderPaginationClick={handleOrderPaginationClick}
                  />
                </PaginationWrapper>
              )}
            </>
          ) : (
            <LoaderWrapper>
              <Loader />
            </LoaderWrapper>
          )}
        </OrdersWrapper>
      </>
    )}
    renderNo={() => <div>No data</div>}
  />
);

OrdersComponent.propTypes = {
  selectedDateFilterObj: PropTypes.shape({}).isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  numberOfPages: PropTypes.number.isRequired,
  ordersList: PropTypes.shape({
    status: PropTypes.string,
  }).isRequired,
  mappedOrdersList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  orderStatusColorEnum: PropTypes.func.isRequired,
  stringsData: PropTypes.shape({}).isRequired,
  selectedStatusFilter: PropTypes.shape({}).isRequired,
  ordersStatusFilterList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  ordersApiCallParams: PropTypes.shape({}),
  filters: PropTypes.shape({}),
  handleOrderStatusFilterClick: PropTypes.func.isRequired,
  handleOrderSearchBarInputChange: PropTypes.func.isRequired,
  handleOrderDateFilterChange: PropTypes.func.isRequired,
  handleOrderPaginationClick: PropTypes.func.isRequired,
  handleGenericFilterClick: PropTypes.func,
  handleGenericMultiFitlerClick: PropTypes.func,
  partnershipTypes: PropTypes.shape({}),
  showPartnersColumn: PropTypes.bool,
  showPaymentColumn: PropTypes.bool,
  permissionsCategories: PropTypes.shape({
    order: PropTypes.string,
  }),
};

OrdersComponent.defaultProps = {
  ordersApiCallParams: {},
  filters: {},
  partnershipTypes: {},
  showPartnersColumn: false,
  showPaymentColumn: false,
  handleGenericFilterClick: () => {},
  handleGenericMultiFitlerClick: () => {},
  permissionsCategories: {},
};

export default OrdersComponent;
